export function generateAIArray(submissionParams) {
    let numberOfInsureds = 0;
    let numberOfAIForms = 0;
    let numberOfLenders = 0;
    let numberOfBankAIForms = 0;
    let submissionFormData = submissionParams;
    if (submissionParams.type === 'ocp' && submissionParams.additionalInsured === 'true') {
        delete submissionFormData.additionalInsured;
    }

    if (submissionFormData.additionalInsured && submissionFormData.additionalInsured === "true") {
        let addForms = submissionFormData.additionalInsuredForms ? submissionFormData.additionalInsuredForms.split(',') : [];
        addForms = addForms.filter(form => {
            return form.indexOf('0413') === -1
        });
        submissionFormData = Object.assign(submissionFormData, {
            additionalInsuredArray: [{
                additionalInsuredName: submissionFormData.additionalInsuredName,
                additionalInsuredOther: submissionFormData.additionalInsuredOther,
                additionalInsuredRelationship: submissionFormData.additionalInsuredRelationship,
                additionalInsuredRelationshipOther: submissionFormData.additionalInsuredRelationshipOther,
                additionalInsuredForms: addForms.toString(),
                additionalInsuredAddress: submissionFormData.additionalInsuredAddress,
                additionalInsuredCity: submissionFormData.additionalInsuredCity,
                additionalInsuredState: submissionFormData.additionalInsuredState,
                additionalInsuredZipCode: submissionFormData.additionalInsuredZipCode,
                banksMortgagees: submissionFormData.banksMortgagees,
            }]
        })
        submissionFormData.additionalInsuredForms = addForms.toString();
        numberOfInsureds = 1;
        numberOfAIForms = submissionFormData.additionalInsuredForms ? submissionFormData.additionalInsuredForms.split(',').length : 0;
        if (submissionFormData.additionalInsuredRelationship ==='Lender/Mortgagee') {
                submissionFormData.banksMortgagees === 'true' ? ++numberOfLenders : numberOfLenders;
                numberOfBankAIForms = submissionFormData.additionalInsuredForms ?
                 submissionFormData.additionalInsuredForms.split(',').length: numberOfBankAIForms;
        }
        submissionFormData = Object.assign(submissionFormData, {numberOfInsureds}, {numberOfAIForms}, {numberOfBankForms: numberOfLenders}, {numberOfBankAIForms})


    if (submissionFormData.additionalInsuredOther && submissionFormData.additionalInsuredOther === "true") {
        let addForms = submissionFormData.secondAdditionalInsuredForms ? submissionFormData.secondAdditionalInsuredForms.split(',') : [];
        addForms = addForms.filter(form => {
            return form.indexOf('0413') === -1
        });
        submissionFormData = Object.assign(submissionFormData, {
            additionalInsuredArray: [{...submissionFormData.additionalInsuredArray[0]}, {
                secondAdditionalInsuredName: submissionFormData.secondAdditionalInsuredName,
                secondAdditionalInsuredOther: submissionFormData.secondAdditionalInsuredOther,
                secondAdditionalInsuredRelationship: submissionFormData.secondAdditionalInsuredRelationship,
                secondAdditionalInsuredRelationshipOther: submissionFormData.secondAdditionalInsuredRelationshipOther,
                secondAdditionalInsuredForms: addForms.toString(),
                secondAdditionalInsuredAddress: submissionFormData.secondAdditionalInsuredAddress,
                secondAdditionalInsuredCity: submissionFormData.secondAdditionalInsuredCity,
                secondAdditionalInsuredState: submissionFormData.secondAdditionalInsuredState,
                secondAdditionalInsuredZipCode: submissionFormData.secondAdditionalInsuredZipCode,
                secondBanksMortgagees: submissionFormData.secondBanksMortgagees,
            }]
            });
        numberOfInsureds = 2;
        submissionFormData.secondAdditionalInsuredForms = addForms.toString();
        const totalAIForms = !!submissionFormData.secondAdditionalInsuredForms ? submissionFormData.secondAdditionalInsuredForms.split(',').length : 0
        numberOfAIForms += totalAIForms;
        if (submissionFormData.secondAdditionalInsuredRelationship ==='Lender/Mortgagee') {

                submissionFormData.secondBanksMortgagees === 'true' ? ++numberOfLenders : numberOfLenders;
              numberOfBankAIForms = submissionFormData.secondAdditionalInsuredForms ?
                submissionFormData.secondAdditionalInsuredForms.split(',').length + numberOfBankAIForms : numberOfBankAIForms;
        }
        submissionFormData = Object.assign(submissionFormData, {numberOfInsureds}, {numberOfAIForms}, {numberOfBankForms: numberOfLenders}, {numberOfBankAIForms})

    if (submissionFormData.secondAdditionalInsuredOther && submissionFormData.secondAdditionalInsuredOther === "true") {
        let addForms = submissionFormData.thirdAdditionalInsuredForms ? submissionFormData.thirdAdditionalInsuredForms.split(',') : [];
        addForms = addForms.filter(form => {
            return form.indexOf('0413') === -1
        });
            submissionFormData = Object.assign(submissionFormData,
                {additionalInsuredArray: [
                    {...submissionFormData.additionalInsuredArray[0]},
                    {...submissionFormData.additionalInsuredArray[1]}, {
                thirdAdditionalInsuredName: submissionFormData.thirdAdditionalInsuredName,
                thirdAdditionalInsuredRelationship: submissionFormData.thirdAdditionalInsuredRelationship,
                thirdAdditionalInsuredRelationshipOther: submissionFormData.thirdAdditionalInsuredRelationshipOther,
                thirdAdditionalInsuredForms: addForms.toString(),
                thirdAdditionalInsuredAddress: submissionFormData.thirdAdditionalInsuredAddress,
                thirdAdditionalInsuredCity: submissionFormData.thirdAdditionalInsuredCity,
                thirdAdditionalInsuredState: submissionFormData.thirdAdditionalInsuredState,
                thirdAdditionalInsuredZipCode: submissionFormData.thirdAdditionalInsuredZipCode,
                thirdBanksMortgagees: submissionFormData.thirdBanksMortgagees,
            }]
        });
        numberOfInsureds = 3;
        submissionFormData.thirdAdditionalInsuredForms = addForms.toString();
        const totalAIForms = !!submissionFormData.thirdAdditionalInsuredForms ? submissionFormData.thirdAdditionalInsuredForms.split(',').length : 0
        numberOfAIForms += totalAIForms;
        if (submissionFormData.thirdAdditionalInsuredRelationship ==='Lender/Mortgagee') {
                submissionFormData.thirdBanksMortgagees === 'true' ? ++numberOfLenders : numberOfLenders;
                numberOfBankAIForms = submissionFormData.thirdAdditionalInsuredForms ?
                    submissionFormData.thirdAdditionalInsuredForms.split(',').length + numberOfBankAIForms : numberOfBankAIForms;
            }
        submissionFormData = Object.assign(submissionFormData, {numberOfInsureds}, {numberOfAIForms}, {numberOfBankForms: numberOfLenders}, {numberOfBankAIForms})

    }
}
}
    if (submissionFormData.additionalInsuredOther === "false") {
        numberOfInsureds = 1;
        submissionFormData = Object.assign(submissionFormData, {numberOfInsureds})
    }
    if (submissionFormData.additionalInsuredArray && submissionFormData.additionalInsured === "false") {
        numberOfInsureds = 0;
        numberOfAIForms = 0;
        numberOfLenders = 0;
        numberOfBankAIForms = 0;
        submissionFormData = Object.assign({}, submissionFormData, {numberOfInsureds: 0}, {numberOfAIForms: 0}, {numberOfBankForms: 0}, {numberOfBankAIForms: 0})
        delete submissionFormData.additionalInsuredArray;
    }

    return submissionFormData;
}
